import React from 'react'
import PropTypes from 'prop-types'
import {get, take, takeRight, first, map} from 'lodash'
import className from 'classnames'
import Head from 'next/head'
import Link from 'next/link'
import dynamic from 'next/dynamic'

import {t, axios} from '@lib/helpers'

const DualSlide = dynamic(() => import('@components/DualSlide'))
const Meta = dynamic(() => import('@components/Meta'))

let scrollTO

const Services = ({services = []}) => {
  const [indexNav, indexNavSet] = React.useState(false)
  const $el = React.useRef()
  const $nav = React.useRef()
  const DATA_SERVICES_ID = 43
  const servicesUpdated = services.map((service) => {
    if (service.id === DATA_SERVICES_ID) {
      const updatedChildren = [
        ...service.children,
        {
          id: 50,
          slug: 'data-labeling',
          title: 'Data Labeling',
          subtitle: '',
        },
      ]
      return {...service, children: updatedChildren}
    }
    return service
  })

  const onScroll = () => {
    window.clearTimeout(scrollTO)

    scrollTO = window.setTimeout(() => {
      const windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight

      if (!$el.current) return
      indexNavSet(
        Math.max(
          0,
          map($el.current.querySelectorAll('.Services__box__h2'), (x) => {
            return x.getBoundingClientRect().top < windowHeight * 0.5
          }).filter((x) => x).length - 1
        )
      )
    }, 20)
  }

  React.useEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <React.Fragment>
      <Meta title={`${t('pages.services.title')} – ${t('layout.title')}`} />

      <div className='Services'>
        <DualSlide>
          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--h1': true,
              'DualSlide__wrapper--h1--blue': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h1
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.services.dualslide.0.h2'),
                }}
              />

              <p className='DualSlide__p'>
                {t('pages.services.dualslide.0.p')}
              </p>
            </div>

            <div className='DualSlide__wrapper__bar'></div>
          </div>

          <div className='DualSlide__image'>
            <img
              className='DualSlide__image__img'
              alt='DualSlide__image__img'
              src='/images/DualSlide--3.jpg'
            />
          </div>
        </DualSlide>

        <div className='BodySpace'>
          {false && (
            <div className='Services__nav' ref={$nav}>
              <div className='container'>
                {servicesUpdated.map((x, i) => (
                  <a
                    key={i}
                    className={className('Services__nav__a', {
                      'Services__nav__a--active': i == indexNav,
                    })}
                    onClick={() => {
                      window.history.pushState(
                        null,
                        null,
                        `#${get(x, 'anchor')}`
                      )

                      document
                        .querySelector(`#${get(x, 'anchor')}`)
                        .scrollIntoView({behavior: 'smooth'})
                    }}
                  >
                    {get(x, 'title')}
                  </a>
                ))}
              </div>
            </div>
          )}

          <div className='Services__boxes' ref={$el}>
            {servicesUpdated.map((x, i) => (
              <div className='Services__box' key={i}>
                <div
                  className='Services__box__handle'
                  id={get(x, 'anchor')}
                ></div>

                <div className='container'>
                  <div className='Services__box__left'>
                    <div className='Services__box__left__wrapper'>
                      <h2 className='Services__box__h2' data-key={i}>
                        {get(x, 'title')}
                      </h2>

                      <img
                        className='Services__box__left__img'
                        alt='Services__box__left__img'
                        src={get(x, 'image_1.url')}
                      />
                    </div>
                  </div>

                  <div className='Services__box__right'>
                    <dl className='Services__box__right__dl'>
                      {(get(x, 'children') || []).map((y, j) => (
                        <Link
                          href='/services/[id]'
                          as={`/services/${get(y, 'slug')}`}
                          key={j}
                        >
                          <a className='Services__box__right__dl__item'>
                            <dt className='Services__box__right__dl__item__dt'>
                              <h3
                                className='Services__box__right__dl__item__dt__h3'
                                dangerouslySetInnerHTML={{
                                  __html: get(y, 'title'),
                                }}
                              />
                            </dt>
                          </a>
                        </Link>
                      ))}
                    </dl>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className='Services__more'>
            <div className='container'>
              <h3 className='Services__more__h3'>
                {t('pages.services.more.h3')}
              </h3>

              <dl className='Services__more__dl'>
                {t('pages.services.more.dl1').map((x, i) => (
                  <div className='Services__more__dl__item' key={i}>
                    <dt className='Services__more__dl__item__dt'>
                      {get(x, 'dt')}
                    </dt>

                    <dd className='Services__more__dl__item__dd'>
                      {get(x, 'dd')}
                    </dd>
                  </div>
                ))}
              </dl>

              <p className='Services__more__center'>
                {t('pages.services.more.center')}
              </p>

              <small className='Services__more__small'>
                {t('pages.services.more.small')}
              </small>

              <dl className='Services__more__dl'>
                {t('pages.services.more.dl2').map((x, i) => (
                  <div className='Services__more__dl__item' key={i}>
                    <dt className='Services__more__dl__item__dt'>
                      {get(x, 'dt')}
                    </dt>

                    <dd className='Services__more__dl__item__dd'>
                      {get(x, 'dd')}
                    </dd>
                  </div>
                ))}
              </dl>

              <div className='Services__more__ps'>
                {t('pages.services.more.ps').map((x, i) => (
                  <p
                    className='Services__more__p'
                    key={i}
                    dangerouslySetInnerHTML={{__html: x}}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Services.propTypes = {}

export const getServerSideProps = async (ctx) => {
  let services

  try {
    services = await axios.get('/services')
  } catch (e) {}

  return {
    props: {
      services: get(services, 'data.data'),
    },
  }
}

export default Services
